// City-specific pages for hyper-local municipal SEO. EN + HI content.

export const cities = [
  {
    slug: "bhubaneswar",
    city: "Bhubaneswar",
    state: "Odisha",
    stateSlug: "odisha",
    headline: "OED in Bhubaneswar — bio-mining at municipal scale.",
    intro:
      "With the Bhubaneswar Municipal Corporation, OED enabled the bio-mining of 2,25,000 metric tonnes of legacy waste and now supports 600–700 tonnes of daily waste with zero odour complaints.",
    stats: [
      { v: "2.25L MT", l: "Legacy waste bio-mined" },
      { v: "600–700 MT", l: "Daily waste managed" },
      { v: "Zero", l: "Odour complaints" },
    ],
    caseSlug: "bhubaneswar-bmc-biomining",
    points: [
      "10–15 chemical products had previously failed at the site.",
      "Work estimated at 9–10 months was completed in four.",
      "95% odour control on day one, 100% within a week.",
    ],
    hi: {
      headline: "भुवनेश्वर में OED — नगरपालिका पैमाने पर बायो-माइनिंग।",
      intro:
        "भुवनेश्वर नगर निगम के साथ, OED ने 2,25,000 मीट्रिक टन पुराने अपशिष्ट की बायो-माइनिंग संभव की और अब शून्य गंध शिकायतों के साथ प्रतिदिन 600–700 टन अपशिष्ट का प्रबंधन करता है।",
      stats: ["बायो-माइन किया गया पुराना अपशिष्ट", "प्रतिदिन प्रबंधित अपशिष्ट", "गंध शिकायतें"],
      points: [
        "साइट पर पहले 10–15 रासायनिक उत्पाद विफल रहे थे।",
        "9–10 महीने का अनुमानित कार्य चार महीने में पूरा हुआ।",
        "पहले दिन 95% गंध नियंत्रण, एक सप्ताह में 100%।",
      ],
    },
  },
  {
    slug: "puri",
    city: "Puri",
    state: "Odisha",
    stateSlug: "odisha",
    headline: "OED in Puri — 100% odour removal in 15 minutes.",
    intro:
      "One of our earliest deployments (2019). On a mixed dumpsite of 80% non-biodegradable and 20% biodegradable waste, OED removed foul smell completely within 15 minutes and cut organic volume by 60%.",
    stats: [
      { v: "100%", l: "Foul smell removed (15 min)" },
      { v: "-60%", l: "Organic volume reduction" },
      { v: "2019", l: "In service since" },
    ],
    caseSlug: "puri-legacy-landfill",
    points: [
      "Suited to temple-town sanitation priorities and tourist footfall.",
      "Rapid demonstration builds public and administrative confidence.",
      "Fully biological — no harsh chemicals near sensitive sites.",
    ],
    hi: {
      headline: "पुरी में OED — 15 मिनट में 100% गंध निवारण।",
      intro:
        "हमारी शुरुआती तैनातियों में से एक (2019)। 80% गैर-जैव-निम्नीकरणीय व 20% जैव-निम्नीकरणीय अपशिष्ट वाले मिश्रित डंपसाइट पर, OED ने 15 मिनट में दुर्गंध पूरी तरह हटा दी और जैविक मात्रा 60% घटाई।",
      stats: ["दुर्गंध हटाई गई (15 मिनट)", "जैविक मात्रा में कमी", "सेवा में तब से"],
      points: [
        "मंदिर-नगर की स्वच्छता प्राथमिकताओं व पर्यटक आवाजाही के अनुकूल।",
        "त्वरित प्रदर्शन जनता व प्रशासन का विश्वास बनाता है।",
        "पूर्णतः जैविक — संवेदनशील स्थलों के पास कोई कठोर रसायन नहीं।",
      ],
    },
  },
  {
    slug: "godda",
    city: "Godda",
    state: "Jharkhand",
    stateSlug: "jharkhand",
    headline: "OED in Godda — five years of odour control.",
    intro:
      "Working with Godda Nagar Parishad since July 2020, OED removes foul smell within 2–5 minutes of application and has sustained clean-air conditions for years.",
    stats: [
      { v: "2–5 min", l: "Odour removal per application" },
      { v: "Jul 2020", l: "In service since" },
      { v: "None", l: "Chemicals required" },
    ],
    caseSlug: "godda-nagar-parishad",
    points: [
      "A durable routine integrated into municipal waste handling.",
      "Consistent results across multiple years and seasons.",
      "A model for other Nagar Parishads in the region.",
    ],
    hi: {
      headline: "गोड्डा में OED — पाँच वर्षों का गंध नियंत्रण।",
      intro:
        "जुलाई 2020 से गोड्डा नगर परिषद के साथ कार्य करते हुए, OED आवेदन के 2–5 मिनट में दुर्गंध हटाता है और वर्षों से स्वच्छ-वायु स्थितियाँ बनाए रखे हुए है।",
      stats: ["प्रति आवेदन गंध निवारण", "सेवा में तब से", "आवश्यक रसायन"],
      points: [
        "नगरपालिका अपशिष्ट प्रबंधन में एकीकृत एक टिकाऊ दिनचर्या।",
        "कई वर्षों व मौसमों में सुसंगत परिणाम।",
        "क्षेत्र के अन्य नगर परिषदों के लिए एक आदर्श।",
      ],
    },
  },
  {
    slug: "chas-bokaro",
    city: "Chas · Bokaro",
    state: "Jharkhand",
    stateSlug: "jharkhand",
    headline: "OED in Chas–Bokaro — seven years of service.",
    intro:
      "Among the longest-running OED engagements — continuous service at the Chas–Bokaro dumpsite, keeping odour in check and supporting land recovery at roughly ₹150 per tonne.",
    stats: [
      { v: "7 years", l: "Continuous service" },
      { v: "₹150/MT", l: "Approx. treatment cost" },
      { v: "up to 70%", l: "Weight reduction" },
    ],
    caseSlug: "chas-bokaro-dumpsite",
    points: [
      "On-site bio-culture production keeps costs low.",
      "A treated tonne reduces to roughly 300 kg of sellable residue.",
      "Turns a cost centre into a modest revenue stream.",
    ],
    hi: {
      headline: "चास–बोकारो में OED — सात वर्षों की सेवा।",
      intro:
        "सबसे लंबे समय तक चलने वाली OED साझेदारियों में से एक — चास–बोकारो डंपसाइट पर निरंतर सेवा, लगभग ₹150 प्रति टन पर गंध नियंत्रण व भूमि पुनर्प्राप्ति में सहयोग।",
      stats: ["निरंतर सेवा", "अनुमानित उपचार लागत", "वज़न में कमी"],
      points: [
        "साइट पर बायो-कल्चर उत्पादन लागत कम रखता है।",
        "उपचारित एक टन घटकर लगभग 300 किग्रा बिक्री-योग्य अवशेष रह जाता है।",
        "लागत केंद्र को एक मामूली राजस्व स्रोत में बदल देता है।",
      ],
    },
  },
  {
    slug: "chandrapur",
    city: "Chandrapur",
    state: "Maharashtra",
    stateSlug: "maharashtra",
    headline: "OED in Chandrapur — RDF odour control at UltraTech Manikgarh.",
    intro:
      "In Chandrapur, OED controls RDF (refuse-derived fuel) odour at UltraTech Cement's Manikgarh plant — neutralising methane, hydrogen sulphide and ammonia in 1–2 minutes, without operational downtime.",
    stats: [
      { v: "1–2 min", l: "Smell neutralised" },
      { v: "22,000 L", l: "Supplied to UltraTech" },
      { v: "CH₄·H₂S·NH₃", l: "Gases neutralised" },
    ],
    caseSlug: "ultratech-cement-rdf",
    points: [
      "Fogged across RDF storage and handling zones at ~1 L/tonne.",
      "Forms a protective bio-film for fresh incoming waste too.",
      "Applicable to municipal landfill sites in the district.",
    ],
    hi: {
      headline: "चंद्रपुर में OED — UltraTech मानिकगढ़ में RDF गंध नियंत्रण।",
      intro:
        "चंद्रपुर में, OED UltraTech Cement के मानिकगढ़ संयंत्र में RDF (रिफ्यूज़-डिराइव्ड फ्यूल) की गंध नियंत्रित करता है — बिना परिचालन बंद किए 1–2 मिनट में मीथेन, हाइड्रोजन सल्फाइड व अमोनिया निष्क्रिय करता है।",
      stats: ["गंध निष्क्रिय", "UltraTech को आपूर्ति", "निष्क्रिय गैसें"],
      points: [
        "RDF भंडारण व हैंडलिंग क्षेत्रों में ~1 ली/टन पर छिड़काव।",
        "ताज़े आने वाले अपशिष्ट के लिए भी एक सुरक्षात्मक बायो-फिल्म बनाता है।",
        "ज़िले के नगरपालिका लैंडफिल स्थलों पर भी लागू।",
      ],
    },
  },
];

export const getCity = (slug) => cities.find((c) => c.slug === slug);
export const citiesByState = (stateSlug) => cities.filter((c) => c.stateSlug === stateSlug);
